<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2"><em>To Tommy, Bret, Patrick, Johnny Ryan, and<br/>Ryan Paul—the next generation’s band of brothers.</em></p>
<p class="ded1"><em>And to my darling Tom,<br/>proud patriarch of the clan.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MontanaLegacy_dedi-1.vue?2355d21f